<script module>
  export const meta = {
    title: 'Pausly on mobile',
    teaser:
      'Pausly is optimized for mobile web usage, eliminating the need for app\ndownloads. Future updates may include mobile apps with additional features.\n',
    sort: 9,
  }
</script>

<p>
  Currently, we don't have mobile apps available, but our web app is fully
  optimized for mobile usage.
</p>
<p>
  Our goal is to streamline your experience by eliminating the need for app
  downloads to join a session.
</p>
<p>
  While we're considering the development of mobile apps in the future for
  features like notifications and Apple Health integration, we hope you enjoy
  the ease of use our current setup offers. Keep an eye out for updates!
</p>
